import { PackagePickerComponents } from "@wix/package-picker-components";
import { PremiumCurrencyApiClient } from "@wix/premium-fed-sdk/api-clients-react";
import { PremiumLocaleProvider } from "@wix/premium-react-text";
import * as React from "react";
import { PackagePickerApiClient } from "./ApiProvider";
import { AutonomousTranslationsProvider } from "./AutonomousTranslationsProvider";
import { PackagePickerLoadingProvider } from "./PackagePickerLoadingProvider";
export const PackagePickerAutonomousContext = /*#__PURE__*/React.createContext({});
export const PackagePickerAutonomousProvider = _ref => {
  let {
    children,
    apiProps,
    translationService,
    callbacks,
    packagePickerType,
    siteGuid
  } = _ref;
  return /*#__PURE__*/React.createElement(PackagePickerAutonomousContext.Provider, {
    value: {
      packagePickerType,
      siteGuid
    }
  }, /*#__PURE__*/React.createElement(PremiumCurrencyApiClient.Provider, {
    httpClient: apiProps.httpClient
  }, /*#__PURE__*/React.createElement(PackagePickerLoadingProvider, {
    callbacks: callbacks
  }, /*#__PURE__*/React.createElement(PackagePickerApiClient.Provider, apiProps, /*#__PURE__*/React.createElement(AutonomousTranslationsProvider, translationService, /*#__PURE__*/React.createElement(_ComponentsProvider, {
    translationService: translationService
  }, children))))));
};
export const usePackagePickerType = () => {
  const context = React.useContext(PackagePickerAutonomousContext);
  if (!context) {
    throw new Error('usePackagePickerType must be used within PackagePickerAutonomousProvider');
  }
  return {
    packagePickerType: context.packagePickerType
  };
};
const _ComponentsProvider = _ref2 => {
  var _currencyState$data;
  let {
    children,
    translationService
  } = _ref2;
  const currencyState = PremiumCurrencyApiClient.hooks.useGetCurrencySettings({});
  if (!((_currencyState$data = currencyState.data) != null && _currencyState$data.currencySettings)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const settings = currencyState.data.currencySettings;
  const localeProps = {
    lng: translationService.i18n.language,
    currencyCode: settings.code,
    currencySettings: {
      [settings.code]: {
        symbol: settings.symbol,
        decimalSep: settings.decimalSeparator,
        fractionSize: settings.minorUnits,
        groupSep: settings.groupSeparator,
        negPrefix: settings.negativePrefix,
        negSuffix: settings.negativeSuffix,
        posPrefix: settings.positivePrefix,
        posSuffix: settings.positiveSuffix
      }
    }
  };
  return /*#__PURE__*/React.createElement(PackagePickerComponents.Provider, {
    localeProps: localeProps,
    translationProps: {
      i18n: translationService.i18n,
      Trans: translationService.Trans
    }
  }, /*#__PURE__*/React.createElement(PremiumLocaleProvider, {
    lng: localeProps.lng,
    currencyCode: localeProps.currencyCode,
    currencySettings: localeProps.currencySettings
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children)));
};
//# sourceMappingURL=PackagePickerAutonomousProvider.js.map